'use client';

import { useInView } from '@/lib/hooks';
import { cn } from '@/lib/utils';
import { PathEnum } from '@/types/enums';
import { useTranslations } from 'next-intl';
import AnimatedArrow from '../ui/AnimatedArrow';
import Link from '../ui/Link';
import TextHuge from '../ui/TextHuge';

export default function HomeHeroTitle() {
    const t = useTranslations();
    const { isInView, elementRef } = useInView();

    return (
        <div ref={elementRef}>
            <TextHuge
                className={cn(
                    'text-white drop-shadow-sm max-w-[1084px] leading-tight max-lg:text-h2 opacity-0 transition-all duration-1000 ease-in-out -translate-x-[100px]',
                    isInView && 'opacity-100 translate-x-0',
                )}
            >
                {t.rich('HomePage.fromConceptToProd', {
                    strong: (chunks) => <span className="font-medium text-brand">{chunks}</span>,
                })}
            </TextHuge>
            <Link
                className={cn(
                    'get-offer-trigger group hover:text-white text-white mt-20 block ml-12 max-lg:ml-10 max-lg:mt-12 max-sm:ml-8 w-fit opacity-0 transition-all duration-1000 ease-in-out -translate-x-[200px]',
                    isInView && 'opacity-100 translate-x-0',
                )}
                href={PathEnum.Contact}
                ariaLabel={t('Footer.contactUs')}
            >
                <>
                    <span className="sr-only">{t('Footer.contactUs')}</span>
                    <AnimatedArrow
                        className="scale-600 max-lg:scale-500 max-sm:scale-600"
                        strokeWidth={1}
                    />
                </>
            </Link>
        </div>
    );
}
